import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

const WalletBalanceCard = ({ children, className = '' }) => {
  return <div className={`wallet-balance-card ${className}`}>{children}</div>;
};

const Title = ({ children, className = '' }) => (
  <span className={`wallet-balance-card__label ${className}`}>{children}</span>
);

const Amount = ({ children, className = '' }) => (
  <h2 className={`wallet-balance-card__amount ${className}`}>{children}</h2>
);

const Value = ({ children, className = '' }) => (
  <span className={className}>{children}</span>
);
const Currency = ({ currency = '₹', className = '' }) => (
  <span className={`wallet-balance-card__currency ${className}`}>
    {currency}
  </span>
);

const Footer = ({ children, className = '' }) => (
  <div className={`wallet-balance-card__footer ${className}`}>{children}</div>
);

const IconWrapper = ({ children, className = '' }) => (
  <div
    className={`wallet-balance-card__icon ${className}`}
    // style={{ background: iconBackground }}
  >
    {children}
    {/* <WalletIcon /> */}
  </div>
);

WalletBalanceCard.Content = ({ children, className }) => (
  <div className={`wallet-balance-card__content ${className}`}>{children}</div>
);

WalletBalanceCard.Content.Title = Title;
WalletBalanceCard.Content.Amount = Amount;
WalletBalanceCard.Content.Amount.Value = Value;
WalletBalanceCard.Content.Amount.Currency = Currency;
WalletBalanceCard.Content.Footer = Footer;
WalletBalanceCard.IconWrapper = IconWrapper;

WalletBalanceCard.propTypes = {
  className: PropTypes.string
};

export default WalletBalanceCard;
